/*
  Media Stack, 28 September 2026. Cross-sell add-to-bag.

  Adds every ticked add-on in one request, then hands the response to whichever cart component the
  theme is using so the drawer redraws exactly as it does after a normal add to bag. Mirrors the
  flow in product-form.js rather than reloading the page.
*/
(function () {
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP'
      }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function cartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function refresh(root) {
    var checks = root.querySelectorAll('.ms-xsell__check');
    var button = root.querySelector('[data-ms-xsell-add]');
    var label = root.querySelector('[data-ms-xsell-label]');
    var totalEl = root.querySelector('[data-ms-xsell-total]');
    var n = 0;
    var total = 0;
    var off = 0;
    checks.forEach(function (c) {
      if (c.checked) {
        n += 1;
        total += parseInt(c.dataset.price, 10) || 0;
        /* data-off is the automatic add-on discount on that row, already floored in Liquid the
           way Shopify allocates it, so the button total never overstates the saving. */
        off += parseInt(c.dataset.off, 10) || 0;
      }
    });
    if (!button) return;
    button.disabled = n === 0;
    if (label) {
      if (n === 0) label.textContent = button.dataset.labelNone;
      else if (n === 1) label.textContent = button.dataset.labelOne;
      else label.textContent = button.dataset.labelMany.replace('[n]', n);
    }
    /* The automatic discount needs a minimum number of entitled units in the basket, and units
       already in the cart count towards it, so data-offer-need is what is still outstanding. Below
       that the saving is not real yet and the button must show the plain total. */
    var need = parseInt(root.dataset.offerNeed, 10);
    if (isNaN(need) || need < 1) need = 1;
    if (totalEl) {
      if (n === 0) {
        totalEl.textContent = '';
      } else if (off > 0 && n >= need) {
        totalEl.innerHTML = '<s class="ms-xsell__was">' + money(total) + '</s> ' + money(total - off);
      } else {
        totalEl.textContent = money(total);
      }
    }
  }

  function add(root) {
    var button = root.querySelector('[data-ms-xsell-add]');
    var note = root.querySelector('[data-ms-xsell-note]');
    var items = [];
    root.querySelectorAll('.ms-xsell__check').forEach(function (c) {
      if (c.checked) items.push({ id: parseInt(c.value, 10), quantity: 1 });
    });
    if (!items.length) return;

    var cart = cartComponent();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    button.classList.add('is-loading');
    button.disabled = true;
    if (note) note.textContent = '';

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          if (note) note.textContent = response.description || response.message || 'That could not be added.';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ms-cross-sell' });
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (e) {
        console.error(e);
        if (note) note.textContent = 'Something went wrong. Please try again.';
      })
      .finally(function () {
        button.classList.remove('is-loading');
        refresh(root);
      });
  }

  function bind(root) {
    if (root.dataset.msBound === '1') return;
    root.dataset.msBound = '1';
    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('ms-xsell__check')) refresh(root);
    });
    var button = root.querySelector('[data-ms-xsell-add]');
    if (button) button.addEventListener('click', function () { add(root); });
    refresh(root);
  }

  function bindAll(scope) {
    (scope || document).querySelectorAll('[data-ms-xsell]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', function () { bindAll(); });
  bindAll();

  /* The cart drawer replaces its own markup after every change, so rebind on each redraw. */
  var observer = new MutationObserver(function () { bindAll(); });
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  });
})();
